import React from 'react'

import { BottomSheet, Stack } from '@zet/design-system'
import { Select } from '@zet/design-system/select'
import { H4, SH1 } from '@zet/design-system/typography'

import { TdsReport } from '../../api/earnings/types'

type SelectTdsOptionsType = {
  title: string
  options: Array<TdsReport | string>
  isBottomSheetVisible: boolean
  setIsBottomSheetVisible: (x: boolean) => void
  setSelectedValue: (x: string) => void
  selectedValue: string
}

const SelectTdsOptions = ({
  title,
  options,
  isBottomSheetVisible,
  setIsBottomSheetVisible,
  setSelectedValue,
  selectedValue,
}: SelectTdsOptionsType) => {
  function onChangeSelect(value: string) {
    setIsBottomSheetVisible(false)
    setSelectedValue(value)
  }

  return (
    <BottomSheet
      visible={isBottomSheetVisible}
      disableBottomSheet={() => setIsBottomSheetVisible(false)}
      onDismiss={() => setIsBottomSheetVisible(false)}
      sheetName="select_tds_options"
    >
      <Stack className="px-3">
        <H4> {title}</H4>
        <Stack className="mt-6">
          <Select onChange={onChangeSelect}>
            {options?.map((value, i) => (
              <Select.Option
                key={i}
                name={value?.label || value}
                selectedValue={selectedValue}
                optionContainerStyle="h-[62] mb-3 w-full justify-center rounded-lg"
              >
                <SH1>{value?.label || value}</SH1>
              </Select.Option>
            ))}
          </Select>
        </Stack>
      </Stack>
    </BottomSheet>
  )
}

export default SelectTdsOptions
